module.exports = __webpack_public_path__ + "static/banner-df09a27f8da0e9d5456088b5e91f818c.jpg";